import {
  BarChart,
  Box,
  File,
  HardDrive,
  Sliders,
  Trello,
  UserCheck,
  Video,
} from 'react-feather';
import React from 'react';
import { routes } from './constants';
import {
  assetConfigurations,
  assetSubRoutesFactory,
  Grid,
  IconStartConnection,
  insertArrayIf,
  NavBarMenu,
  NavBarStructure,
  permissionsAndSubRoutesFactory,
} from '@mss/mss-component-library';
import { permissionSet } from '../authorization/util/permissionSets';
import MssIcon from './MssIcon';
import '../../scss/navbar.scss';
import { useConfigurationQuery } from '../index';

const assetSubRoutes = assetSubRoutesFactory({
  configs: assetConfigurations,
  category: 'assets',
  addDiscovery: true,
});
const applicationSubRoutes = assetSubRoutesFactory({
  configs: assetConfigurations,
  category: 'applications',
  addDiscovery: true,
});

const navbarConfig = (unidirectional?: boolean): NavBarStructure[][] => [
  [
    {
      route: routes.STATUS,
      icon: <BarChart className="mr-1 mb-1" size={14} />,
      label: 'Status',
      permissions: [],
    },
    {
      route: routes.APPLICATIONS,
      label: 'Applications',
      icon: <Box className="mr-1 mb-1" size={14} />,
      ...permissionsAndSubRoutesFactory(applicationSubRoutes),
    },
    {
      route: routes.ASSETS,
      label: 'Assets',
      icon: <HardDrive className="mr-1 mb-1" size={14} />,
      ...permissionsAndSubRoutesFactory(assetSubRoutes),
    },
    ...insertArrayIf(!unidirectional, [
      {
        route: routes.SESSIONS,
        label: 'Sessions',
        icon: <Video className="mr-1 mb-1" size={14} />,
        ...permissionsAndSubRoutesFactory([
          [
            {
              route: routes.SESSION_REQUESTS,
              label: 'Requests',
              permissions: ['admin_view_remoterequest'],
            },
            {
              route: routes.SESSION_SESSIONS,
              label: 'Sessions',
              permissions: ['admin_view_remotesession'],
            },
          ],
        ]),
      },
    ]),
    {
      route: routes.AUTH,
      label: 'Authorizations',
      icon: <UserCheck className="mr-1 mb-1" size={14} />,
      ...permissionsAndSubRoutesFactory([
        [
          {
            route: routes.AUTH_USERS,
            label: 'Users',
            permissions: permissionSet.userViewAny,
          },
          {
            route: routes.AUTH_GROUPS,
            label: 'Groups',
            permissions: permissionSet.groupViewAny,
          },
        ],
      ]),
    },
    {
      route: routes.ACTIVITY_LOG,
      label: 'Activity Log',
      icon: <Trello className="mr-1 mb-1" size={14} />,
      permissions: ['view_activitylog'],
    },
    {
      route: routes.CONFIG,
      label: 'Configuration',
      icon: <Sliders className="mr-1 mb-1" size={14} />,
      permissions: permissionSet.configurationViewAny,
    },
  ],
  [
    ...insertArrayIf(!unidirectional, [
      {
        route: routes.REMOTE_ACCESS,
        label: 'Remote Access',
        icon: <MssIcon icon={IconStartConnection} className="mr-1 mb-1" />,
        permissions: permissionSet.remoteAny,
      },
      {
        route: routes.FILE_TRANSFER,
        label: 'File Transfer',
        icon: <File className="mr-1 mb-1" size={14} />,
        permissions: permissionSet.fileTransferViewAny,
      },
    ]),
  ],
];

const Navbar = () => {
  const { data: config } = useConfigurationQuery();
  return (
    <div id="mss-navbar">
      <Grid.Container>
        <NavBarMenu navbarStructure={navbarConfig(config?.unidirectional)} />
      </Grid.Container>
    </div>
  );
};

export default Navbar;
